export default __webpack_public_path__ + "static/media/Rectangle 5.9917f890.png";